import React from 'react'
import type { CarouselBlock as CarouselBlockProps } from '@/payload-types'
import { isMedia } from '@/lib/utils'
import Image from 'next/image'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from '@/components'

export function CarouselBlock({
  title,
  lead,
  images,
}: Readonly<CarouselBlockProps>): React.ReactNode {
  return (
    <section className="group p-8 [.group+&]:border-t">
      <div className="flex flex-col max-w-7xl mx-auto gap-8">
        {title || lead ? (
          <header className="lg:flex-1 flex flex-col gap-2 self-center text-center">
            {title ? <h2 className="text-lg lg:text-xl font-semibold">{title}</h2> : null}
            {lead ? <p className="text-sm">{lead}</p> : null}
          </header>
        ) : null}
        {images ? (
          <Carousel className="border p-4 rounded-xl">
            <CarouselContent>
              {images.map((image) =>
                isMedia(image) && image.url ? (
                  <CarouselItem key={image.id}>
                    <figure key={image.id}>
                      <Image
                        src={image.url}
                        alt={image.alt}
                        width={Number(image.width)}
                        height={Number(image.height)}
                      />
                    </figure>
                  </CarouselItem>
                ) : null,
              )}
            </CarouselContent>
            <CarouselPrevious />
            <CarouselNext />
          </Carousel>
        ) : null}
      </div>
    </section>
  )
}
